<template>
  <div class="event-management-wrap">
    <div class="header-container">
      <div class="header-title">买量事件管理</div>
      <el-button type="primary" @click="handleAdd">+ 新增事件</el-button>
    </div>

    <div class="filter-container">
      <div class="filter">
        <el-input v-model="search" style="width: 240px" placeholder="搜索事件名称"></el-input>
        <product-select
          multiple
          :value.sync="products"
          placeholder="请选择产品"
          :isDefault="false"
          popper-class="BI-select BI-select-product"
        ></product-select>
        <el-select v-model="statusFilter" style="width: 160px; margin-left: 16px" placeholder="全部状态">
          <el-option label="全部状态" value=""></el-option>
          <el-option label="启用中" value="1"></el-option>
          <el-option label="已禁用" value="0"></el-option>
        </el-select>
        <el-button type="primary" style="margin-left: 16px" @click="searchData">查询</el-button>
        <el-button style="margin-left: 8px" @click="resetFilter">重置</el-button>
      </div>
    </div>

    <el-table
      :data="list"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      ref="table"
      class="event-table"
      @sort-change="sortChange"
    >
      <el-table-column label="序号" type="index" width="80" align="center">
        <template slot-scope="scope">
          {{ (pageData.page - 1) * pageData.size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="事件名称" prop="eventName" min-width="150"></el-table-column>
      <el-table-column label="产品" prop="productDisplay" min-width="200">
        <template slot-scope="scope">
          <el-popover
            placement="right"
            width="400"
            trigger="hover"
            :disabled="!scope.row.productDisplay"
            popper-class="product-popover"
          >
            <div class="product-popover-content">
              {{ scope.row.productDisplay }}
            </div>
            <div slot="reference" class="product-display-multiline">
              {{ scope.row.productDisplay || '-' }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="notes" min-width="200"></el-table-column>
      <el-table-column label="操作人" prop="creator" min-width="200"></el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="180" sortable></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" width="180" sortable></el-table-column>
      <el-table-column label="状态" prop="status" width="150" align="center">
        <template slot-scope="scope">
          <div class="status-cell">
            <span :class="['status-text', scope.row.status == 1 ? 'status-active' : 'status-disabled']">
              {{ scope.row.status == 1 ? '启用中' : '已禁用' }}
            </span>
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="handleStatusChange(scope.row)"
            ></el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <div class="action-btn-wrap">
            <el-button type="text" class="action-btn view-btn" @click="handleView(scope.row)">查看</el-button>
            <el-button type="text" class="action-btn edit-btn" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" class="action-btn copy-btn" @click="handleCopy(scope.row)">复制</el-button>
            <el-button type="text" class="action-btn delete-btn" @click="handleDelete(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <self-pagination
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      @getCurrentPage="changePage"
      @handleSizeChange="handleSizeChange"
    ></self-pagination>
  </div>
</template>

<script>
import { getBuyEventPageList, deleteBuyEvent, updateBuyEventStatus } from '@/api/eventManager-old'

export default {
  name: 'AcquisitionEventManagementOld',
  data() {
    return {
      search: '',
      products: [],
      statusFilter: '',
      list: [],
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      loading: false,
      orderField: '',
      orderType: '',
    }
  },

  mounted() {
    this.searchData()
  },

  methods: {
    sortChange({ prop, order }) {
      if (order) {
        this.orderField = prop
        this.orderType = order === 'ascending' ? 'asc' : 'desc'
      } else {
        this.orderField = ''
        this.orderType = ''
      }
      this.pageData.page = 1
      this.pageData.size = 10
      this.searchData()
    },
    resetFilter() {
      this.search = ''
      this.statusFilter = ''
      this.products = []
      this.pageData.page = 1
      this.searchData()
    },
    async searchData() {
      try {
        this.loading = true
        const params = {
          eventName: this.search,
          pageNum: this.pageData.page,
          pageSize: this.pageData.size,
          productIds: this.products,
        }

        if (this.orderField) {
          params.orderField = this.orderField
          params.orderType = this.orderType
        }

        // 只有当statusFilter有值时才传递status参数
        if (this.statusFilter !== '') {
          params.status = this.statusFilter
        }

        const res = await getBuyEventPageList(params)

        if (res.code === '0000') {
          this.list = res.data.list || []
          this.pageData.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '获取列表数据失败')
        }
      } catch (error) {
        console.error('获取列表数据失败:', error)
        this.$message.error('获取列表数据失败')
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      // 跳转到新增事件页面
      this.$router.push({
        name: 'AcquisitionEventManagementAddOld',
        query: { mode: 'add' },
      })
    },
    handleView(data) {
      // 跳转到查看事件详情页面
      this.$router.push({
        name: 'AcquisitionEventManagementAddOld',
        query: { mode: 'view', id: data.id },
      })
    },
    handleEdit(data) {
      // 跳转到编辑事件页面
      this.$router.push({
        name: 'AcquisitionEventManagementAddOld',
        query: { mode: 'edit', id: data.id },
      })
    },
    handleCopy(data) {
      // 复制事件 - 跳转到新增页面并传递复制来源ID
      this.$router.push({
        name: 'AcquisitionEventManagementAddOld',
        query: { mode: 'copy', id: data.id },
      })
    },
    async handleDelete(data) {
      // 删除事件
      this.$confirm(`确定要删除事件"${data.eventName}"吗？删除后将无法恢复。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          try {
            const res = await deleteBuyEvent({ id: data.id })

            if (res.code === '0000') {
              this.$message.success('删除成功')
              // 如果当前页只有一条数据且不是第一页，则返回上一页
              if (this.list.length === 1 && this.pageData.page > 1) {
                this.pageData.page--
              }
              this.searchData()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          } catch (error) {
            console.error('删除事件失败:', error)
            this.$message.error('删除失败')
          }
        })
        .catch(() => {})
    },
    async handleStatusChange(data) {
      // 修改状态
      const statusText = data.status === 1 ? '启用' : '禁用'
      this.$confirm(`确定要${statusText}该事件吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          try {
            const res = await updateBuyEventStatus({
              id: data.id,
              status: data.status,
            })

            if (res.code === '0000') {
              this.$message.success(`${statusText}成功`)
              this.searchData()
            } else {
              data.status = data.status === 1 ? 0 : 1
            }
          } catch (error) {
            console.error('修改状态失败:', error)
            this.$message.error(`${statusText}失败`)
            // 恢复原状态
            data.status = data.status === 1 ? 0 : 1
          }
        })
        .catch(() => {
          // 用户取消，恢复原状态
          data.status = data.status === 1 ? 0 : 1
        })
    },
    changePage(page) {
      this.pageData.page = page
      this.searchData()
    },
    handleSizeChange(size) {
      this.pageData.size = size
      this.pageData.page = 1
      this.searchData()
    },
  },
}
</script>

<style lang="less" scoped>
.event-management-wrap {
  margin: 16px;
  height: calc(100vh - 110px);
  padding: 16px 24px 16px 24px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);

  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    .header-title {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
    }
  }

  .filter-container {
    margin-bottom: 16px;

    .filter {
      display: flex;
      align-items: center;

      .product-multi-select {
        margin-left: 16px;
        /deep/.el-input__inner {
          height: 32px;
        }
      }
    }
  }

  .event-table {
    margin-bottom: 16px;

    .status-cell {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      .status-text {
        font-size: 13px;
        padding: 2px 8px;
        border-radius: 2px;

        &.status-active {
          color: #52c41a;
          background-color: #f6ffed;
        }

        &.status-disabled {
          color: rgba(0, 0, 0, 0.45);
          background-color: #f5f5f5;
        }
      }
    }

    .action-btn-wrap {
      .el-button + .el-button {
        margin-left: 8px;
      }
    }

    .action-btn {
      padding: 0 2px;
      font-size: 13px;

      &.view-btn {
        color: #1890ff;
      }

      &.edit-btn {
        color: #1890ff;
      }

      &.copy-btn {
        color: #1890ff;
      }

      &.delete-btn {
        color: #ff4d4f;
      }
    }
  }

  // 产品列展示样式 - 最多3行，超出显示省略号
  .product-display-multiline {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    word-break: break-all;
    max-height: 4.5em; // 3行 * 1.5行高
    cursor: pointer;
  }

  .footer-page {
    margin-top: 16px;
    text-align: right;
  }
}

// Element UI 组件样式覆盖
::v-deep .el-button--primary {
  background-color: #1890ff;
  border-color: #1890ff;

  &:hover {
    background-color: #40a9ff;
    border-color: #40a9ff;
  }
}

::v-deep .el-switch.is-checked .el-switch__core {
  background-color: #1890ff;
  border-color: #1890ff;
}

::v-deep .el-table th {
  background-color: #fafafa;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}

::v-deep .el-table {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
}

// Popover 样式
::v-deep .product-popover {
  max-width: 500px;
  word-break: break-all;

  .product-popover-content {
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.85);
    font-size: 13px;
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
